// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishList/OperationBtn.less
// module id = 1620
// module chunks = 0